"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ActivityFeedContext = require("./Functionality/ActivityFeed/ActivityFeedContext");
var _NavItem = _interopRequireDefault(require("./NavItem.render"));
var _NavContext = require("../../../../context/NavContext");
var _useScreenSize = require("../../../hooks/useScreenSize");
const NavItemComponent = props => {
  const {
    menuItemId,
    showAsButton,
    openChangePasswordModal
  } = props;
  const navItemRef = _react.default.useRef(null);
  // we set this to true only if the icon is alerts
  const [hasEverClickedAlertsFeed, setAlertsFeedClicked] = _react.default.useState(true);
  const {
    windowWidth
  } = (0, _useScreenSize.useScreenSize)();
  const {
    setClickedItem,
    startHovering,
    itemSelected
  } = (0, _react.useContext)(_NavContext.NavContext);
  const setRef = () => navItemRef;
  const handleNavItemSelected = () => {
    startHovering(menuItemId);
  };
  const handleNavItemDeselected = () => {
    startHovering(undefined);
  };
  return /*#__PURE__*/_react.default.createElement(_ActivityFeedContext.AlertsFeedContext.Provider, {
    value: {
      hasEverClickedAlertsFeed,
      setAlertsFeedClicked
    }
  }, /*#__PURE__*/_react.default.createElement(_NavItem.default, Object.assign({}, props, {
    selected: itemSelected === menuItemId,
    setClickedItem: setClickedItem,
    showAsButton: showAsButton !== undefined && windowWidth >= 1080,
    onNavItemSelected: handleNavItemSelected,
    onNavItemDeselected: handleNavItemDeselected,
    setRef: setRef,
    navItemRef: navItemRef.current,
    openChangePasswordModal: openChangePasswordModal
  })));
};
var _default = exports.default = NavItemComponent;